// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--5fboF","text_container":"index-module--text_container--34ubf","contrast":"index-module--contrast--upsRv"};